import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { connect } from 'react-redux';

function ParametersTableHeader(props) {
    const { translate, Intl } = props;
    return (
        <thead>
            <tr>
                <th className='name'>{translate('parameters__name')}</th>
                <th className='type'>{translate('parameters__type')}</th>
                <th className='description'>{translate('parameters__description')}</th>
                <th className='default'>{translate('parameters__default')}</th>
            </tr>
        </thead>
    );
}
function mapStateToProps(state) {
    return {
        Intl: state.Intl,
    }
}
export default connect(mapStateToProps)(withTranslate(ParametersTableHeader));